import { Grid, TextField } from '@mui/material';
import { Field, type FormikErrors, type FormikTouched } from 'formik';
import InputMask from 'react-input-mask';

interface FormContentProps {
  values: any;
  errors: FormikErrors<any>;
  touched: FormikTouched<any>;
  isSubmitting: boolean;
  setFieldValue: (field: string, value: any) => void;
}

export function FormContent({
  values,
  errors,
  touched,
  isSubmitting,
  setFieldValue,
}: FormContentProps) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="Nome"
          name="name"
          required
          disabled={isSubmitting}
          error={!!(touched.name && errors.name)}
          helperText={touched.name && errors.name}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          as={TextField}
          fullWidth
          label="E-mail"
          name="email"
          required
          disabled={isSubmitting}
          error={!!(touched.email && errors.email)}
          helperText={touched.email && errors.email}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputMask
          mask="999.999.999-99"
          value={values.cpf || ''}
          onChange={e => setFieldValue('cpf', e.target.value)}
          disabled={isSubmitting}
        >
          {(inputProps: any) => (
            <TextField
              {...inputProps}
              fullWidth
              label="CPF"
              name="cpf"
              required
              error={!!(touched.cpf && errors.cpf)}
              helperText={touched.cpf && errors.cpf}
            />
          )}
        </InputMask>
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputMask
          mask="(99) 99999-9999"
          value={values.phone || ''}
          onChange={e => setFieldValue('phone', e.target.value)}
          disabled={isSubmitting}
        >
          {(inputProps: any) => (
            <TextField
              {...inputProps}
              fullWidth
              label="Telefone"
              name="phone"
              required
              error={!!(touched.phone && errors.phone)}
              helperText={touched.phone && errors.phone}
            />
          )}
        </InputMask>
      </Grid>
    </Grid>
  );
}